import { defineStore } from "pinia";

const snackbarColors = {
  success: "success",
  error: "error",
  warning: "warning",
  default: "primary",
} as const;

type SnackbarColorType = keyof typeof snackbarColors;

export const useSnackbarStore = defineStore("snackbar", {
  state: (): {
    snackbar: {
      message: string;
      color: string;
      visible: boolean;
      actionLabel: string | null;
      onAction: (() => void) | null;
    };
  } => ({
    snackbar: {
      message: "",
      color: snackbarColors.success,
      visible: false,
      actionLabel: null,
      onAction: null,
    },
  }),

  getters: {
    snackbarState: (state) => state.snackbar,
  },

  actions: {
    showSnackbar({
      message,
      type = "default",
      actionLabel = null,
      onAction = null,
    }: {
      message: string;
      type?: SnackbarColorType;
      actionLabel?: string | null;
      onAction?: (() => void) | null;
    }) {
      this.snackbar.visible = true;
      this.snackbar.message = message;
      this.snackbar.color = snackbarColors[type];
      this.snackbar.actionLabel = actionLabel;
      this.snackbar.onAction = onAction;
    },

    showSuccess(message: string) {
      this.showSnackbar({ message, type: "success" });
    },

    showError(message: string) {
      this.showSnackbar({ message, type: "error" });
    },

    /** Löst die hinterlegte Aktion aus und schließt den Snackbar. */
    triggerAction() {
      const action = this.snackbar.onAction;
      this.hideSnackbar();
      if (typeof action === "function") action();
    },

    hideSnackbar() {
      this.snackbar.visible = false;
      this.snackbar.actionLabel = null;
      this.snackbar.onAction = null;
    },
  },
});
